import { Spin } from 'antd';
import type { IBtlDocument } from '@api/documents/types';
import { OverviewPage } from '@pages/OverviewPage/OverviewPage';
import { useCaseTasks } from '@queries/brokerCases/useCaseTasks';
import { usePrefetchDocumentReviews } from '@queries/brokerCases/usePrefetchDocumentReviews';
import { useBtlDocuments } from '@queries/btlApplications/useBtlDocuments';
import { useMemo } from 'react';

interface OoCustomerFilesPageProps {
  caseId: string;
  isBankDetailsComplete: boolean;
  onGoToEvidence: () => void;
  onGoToBankDetails: () => void;
}

export function OoCustomerFilesPage({
  caseId,
  isBankDetailsComplete,
  onGoToEvidence,
  onGoToBankDetails,
}: OoCustomerFilesPageProps) {
  const { data: caseTasksData, isLoading: isCaseTasksLoading } = useCaseTasks(caseId);
  const { data: documents, isLoading: isDocumentsLoading } = useBtlDocuments(caseId);
  const sections = caseTasksData?.sections ?? [];

  usePrefetchDocumentReviews(caseId, sections);

  const applicationFilesInternal = useMemo(
    () => (documents ?? []).filter((doc: IBtlDocument) => doc.source === 'INTERNAL' && !doc.isDeleted),
    [documents],
  );

  if ((isCaseTasksLoading && !caseTasksData) || (isDocumentsLoading && !documents)) {
    return <Spin size='large' />;
  }

  return (
    <OverviewPage
      sections={sections}
      applicationFilesInternal={applicationFilesInternal}
      showBankDetailsTask
      isBankDetailsComplete={isBankDetailsComplete}
      onGoToEvidenceV2={onGoToEvidence}
      onGoToBankDetails={onGoToBankDetails}
    />
  );
}
